import api from '@/api'
import { setStroeDemo, setIsIOS, setIsPC, setErpEncrypted, setErp } from '@/store/features/appCommonSlice'
import store from '@/store'

// 获取子APP入口
export const setCommonStore = () => {
  store.dispatch(setStroeDemo('这是个公共的store'))
}

// 判断是否是IOS
export function checkIOS() {
  const isIos = /iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase())
  store.dispatch(setIsIOS(isIos))
}

// 判断是否使用PC端样式
export function checkPC() {
  const isPC = window.innerWidth >= 1080
  store.dispatch(setIsPC(isPC))
}

export function getUrlParams() {
  const obj = {}
  const url = window.location.href
  if (url.indexOf('?') !== -1) {
    const query = url.split('?')[1]
    const subArr = query.split('&')
    for (let i = 0; i < subArr.length; i++) {
      const arr = subArr[i].split('=')
      obj[arr[0]] = arr[1]
    }
  }
  return obj
}

// 获取thirdName
function setCookie(cname, cvalue, exdays) {
  let d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  let expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + '; ' + expires + '; path=/; domain=jd.com'
}

